module.exports = __webpack_public_path__ + "media/images/Cup-and-Candle-1920px-1-28fd378b84977865488de32758481b9c.png";